import { Fragment, useMemo, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';

export default function SendThankYouModal({ isOpen, onClose, toMember, onSubmit }) {
  const [saleAmount, setSaleAmount] = useState('');
  const [message, setMessage] = useState('');

  const canSubmit = useMemo(() => {
    const amount = Number(saleAmount);
    return Number.isFinite(amount) && amount >= 0;
  }, [saleAmount]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!toMember?.id) return;

    await onSubmit({
      toMemberId: toMember.id,
      saleAmount: Number(saleAmount),
      message: String(message).trim() || null,
    });

    setSaleAmount('');
    setMessage('');
    onClose();
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0">
          <div className="fixed inset-0 bg-black/30" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0 scale-95" enterTo="opacity-100 scale-100" leave="ease-in duration-200" leaveFrom="opacity-100 scale-100" leaveTo="opacity-0 scale-95">
              <Dialog.Panel className="w-full max-w-xl transform overflow-hidden rounded-lg bg-white shadow-xl transition-all">
                <div className="px-6 py-5">
                  <Dialog.Title className="text-xl font-playfair-sans text-NBNA-primary">
                    Send Thank You
                  </Dialog.Title>
                  <p className="mt-1 text-sm text-gray-600">
                    To: <span className="font-medium">{toMember?.businessName || toMember?.name}</span>
                  </p>

                  <form onSubmit={handleSubmit} className="mt-5 space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="ty-saleAmount">Sale amount</label>
                      <input
                        id="ty-saleAmount"
                        type="number"
                        min="0"
                        step="0.01"
                        className="input-field w-full"
                        value={saleAmount}
                        onChange={(e) => setSaleAmount(e.target.value)}
                        required
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="ty-message">Message (optional)</label>
                      <textarea
                        id="ty-message"
                        className="input-field w-full"
                        rows={4}
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        placeholder="Quick note about the referral impact"
                      />
                    </div>

                    <div className="mt-6 flex justify-end gap-3">
                      <button type="button" className="btn-secondary" onClick={onClose}>
                        Cancel
                      </button>
                      <button type="submit" className="btn-primary" disabled={!canSubmit}>
                        Send Thank You
                      </button>
                    </div>
                  </form>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
